import React, { useId } from 'react';

interface OnboardingBackgroundProps {
  children: React.ReactNode;
}

/**
 * Full-viewport paper with the canvas's dot grid, so onboarding feels like
 * the board it leads to. Follows light and dark through the tokens.
 */
export function OnboardingBackground({ children }: OnboardingBackgroundProps) {
  const patternId = useId();
  const gridSize = 24;
  const dotRadius = 1.2;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden bg-paper">
      <div className="pointer-events-none absolute inset-0">
        <svg width="100%" height="100%" style={{ display: 'block' }} aria-hidden="true">
          <defs>
            <pattern id={patternId} width={gridSize} height={gridSize} patternUnits="userSpaceOnUse">
              <circle cx={gridSize / 2} cy={gridSize / 2} r={dotRadius} fill="hsl(var(--canvas-dot))" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill={`url(#${patternId})`} />
        </svg>
      </div>

      <div className="relative z-10 flex w-full items-center justify-center px-4">{children}</div>
    </div>
  );
}
